/* eslint-disable max-len */
import {AuthenticationResult,
  Configuration,
  IPublicClientApplication} from '@azure/msal-browser';
import {
  emailChangePolicy,
  profileChangePassPolicy,
  resetPassPolicy
} from '../constants/constants';

export const msalConfig: Configuration = {
  auth: {
    clientId: `${process.env.REACT_APP_APPLICATION_ID}`,
    authority: `${process.env.REACT_APP_APPLICATION_ID_URI}${process.env.REACT_APP_APPLICATION_SIGN_IN_POLICY}`,
    knownAuthorities: ['FlowPatternsDev01.b2clogin.com', 'SenecaProd.b2clogin.com'],
    redirectUri: `${window.location.origin}`,
    postLogoutRedirectUri: window.location.pathname.includes('login') ? `${window.location.origin}` : window.location.href
  },
  cache: {
    cacheLocation: 'localStorage'
  },
  system: {
    allowRedirectInIframe: true
  }
};

export const PASSWORD_CHANGE_REQUEST = {
  authority: `${process.env.REACT_APP_APPLICATION_ID_URI}B2C_1A_profile_edit_password_change`,
  redirectUri: `${window.location.origin}`,
  scopes: ['openid']
};

export const loginRequest = {
  scopes: [`${process.env.REACT_APP_APPLICATION_SCOPES}`, 'openid', 'offline_access']
};

export const handlePolicyChange = (
    response: Nullable<AuthenticationResult>,
    instance: IPublicClientApplication
) => {
  const policyName = response?.idTokenClaims['acr'].toLowerCase();

  if (
    policyName === profileChangePassPolicy ||
    policyName === resetPassPolicy ||
    policyName?.includes(emailChangePolicy)
  ) {
    instance.logoutRedirect({
      postLogoutRedirectUri: `${window.location.href}`
    });
  }
};
